export enum UserFeedComputedStatus {
  Ok = "OK",
  RequiresAttention = "REQUIRES_ATTENTION",
  ManuallyDisabled = "MANUALLY_DISABLED",
  Retrying = "RETRYING",
}
